import { Component, OnInit, Input, Output, EventEmitter, ElementRef, ViewChildren } from "@angular/core";
import { FormGroup, FormControl, FormBuilder, Validators, FormControlName } from "@angular/forms";

import { GenericFormValidator } from "../../validators/genericFormArray.validator";

import { INote } from "./model/INote";

import { ToastrService } from "ngx-toastr";
import { BsModalRef, BsModalService } from "ngx-bootstrap/modal";
import { NotesService } from "./services/notes.service";

import "quill-emoji";
import { ValidationMessages, ValidationRules } from "../../models/validationMessage";
import { Observable, fromEvent, merge, Subject } from "rxjs";
import { debounceTime } from "rxjs/operators";
import { Router } from "@angular/router";

@Component({  
  templateUrl: "./note-edit-modal.component.html",
  styleUrls: ["./note-edit-modal.component.css"]
})
export class NoteEditModalComponent implements OnInit {
  @ViewChildren(FormControlName, { read: ElementRef }) formInputElements: ElementRef[];

  public onClose: Subject<boolean>;

  currentNote: INote;

  readonly: boolean = false;

  @Output() returnData: EventEmitter<any> = new EventEmitter();

  noteForm: FormGroup;

  // Use with the generic validation message class   
  displayMessage = new ValidationMessages();
  private genericValidator: GenericFormValidator;
  private validationRules = new ValidationRules();

  content: string = "";

  errmsg: string = "";

  editorStyle = {
    height: "200px"
  }

  quillConfig = {
    toolbar: {
      container: [
        ["bold", "italic", "underline", "strike"],        // toggled buttons
        ["code-block"],
        [{ 'header': 1 }, { 'header': 2 }],               // custom button values
        [{ 'list': "ordered" }, { 'list': "bullet" }],
        [{ 'script': "sub" }, { 'script': "super" }],      // superscript/subscript
        [{ 'indent': "-1" }, { 'indent': "+1" }],          // outdent/indent
        [{ 'direction': "rtl" }],                         // text direction
        [{ 'size': ["small", false, "large", "huge"] }],  // custom dropdown
        [{ 'header': [1, 2, 3, 4, 5, 6, false] }],
        [{ 'font': [] }],
        [{ 'align': [] }],
        ["clean"],                                         // remove formatting button
        ["emoji"]
      ],
    }
  }    

  constructor(private _router: Router, private notesService: NotesService,
    private toastr: ToastrService, private fb: FormBuilder, public bsModalRef: BsModalRef, private modalService: BsModalService) {
    this.validationRules.Messages = {
      Title: {
        required: "Please include a Title to the note"
      },
      Content: {
        required: "Make sure to add text for your note"
      }

    }
    this.genericValidator = new GenericFormValidator(this.validationRules);
  }

  ngAfterViewInit(): void {
    // Watch for the blur event from any input element on the form.
    let controlBlurs: Observable<any>[] = this.formInputElements
      .map((formControl: ElementRef) => fromEvent(formControl.nativeElement, 'blur'));

    // Merge the blur event observable with the valueChanges observable    
    merge(this.noteForm.valueChanges, ...controlBlurs).pipe(
      debounceTime(500)
    ).subscribe(value => {
      this.displayMessage = this.genericValidator.processMessages(this.noteForm);
    });

  }

  ngOnInit() {

    this.onClose = new Subject();

    this.noteForm = this.fb.group({
      id: [],
      title: ['', Validators.required],
      content: ['', Validators.required],
      programId: [1]
    });

    if (this.currentNote != null && !this.readonly) { // no note previously added 
      this.noteForm.patchValue({ title: this.currentNote.title, content: this.currentNote.content });
    }
    
  }

  loadNote() {

    this.notesService.getNotesById(this.currentNote.id).subscribe(result => {
      this.currentNote = result;
      this.noteForm.patchValue({ title: this.currentNote.title, content: this.currentNote.content });
    });

  }

  deleteNote() {

    if (confirm("Are you sure you wan to dete this note?")) {

    this.notesService.deleteNotesById(this.currentNote.id)
      .subscribe({
        next: () => { this.onClose.next(true); },
        error: err => { this.errmsg = "An error occured while deleting the note."; this.onClose.next(false); }
      });

    }

  }

  editNote() {
    this.bsModalRef.hide();
    const step = this.currentNote.step.split('');
    this._router.navigate([`/employment101/guide/${step[0]}/${step[1]}/${step[2]}/${step[3]}`]);
  }

  saveNote() {

    this.errmsg = "";

    if (this.noteForm.valid) {

      const curntNote = Object.assign({} as INote, this.noteForm.value);

      if (this.currentNote == null) {

        this.currentNote = curntNote;
        this.currentNote.id = 0;
        this.currentNote.programId = 0;
        this.currentNote.program = "Personal";

      } else {

        this.currentNote.title = curntNote.title;
        this.currentNote.content = curntNote.content;

      }

      this.notesService.saveNotes(this.currentNote)
        .subscribe({
          next: () => { this.onClose.next(true); },
          error: err => { this.errmsg = "An error occured while saving the note."; this.onClose.next(false);}
        });

    } else {
      this.errmsg = 'Error! The content or the title of the note cannot be blank!';
    }

  }

}
